module.exports = __webpack_public_path__ + "static/img/slogan.9add296.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/aboutus/slogan.jpg
// module id = PBB1
// module chunks = 18